/**
 * Assembly planner styles - Re-exports all split style files as a single export
 * This maintains backwards compatibility with the original L export
 */
import { AssemblyLayout } from './AssemblyLayout';
import { AssemblyNodes } from './AssemblyNodes';
import { AssemblyConnections } from './AssemblyConnections';
import { AssemblyControls } from './AssemblyControls';

export const L = {
    ...AssemblyLayout,
    ...AssemblyNodes,
    ...AssemblyConnections,
    ...AssemblyControls,
};

// Also export individual modules for granular imports
export { AssemblyLayout, AssemblyNodes, AssemblyConnections, AssemblyControls };
